import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Input from 'components/Input';
import styles from './OnboardingForm.module.scss';

export default function InputField({
  error,
  fieldName,
  inputRef,
  labelText,
  testid,
  trailingText,
  type,
  validating,
  ...otherProps
}) {
  return (
    <div className={styles.topLabel}>
      <label htmlFor={fieldName}>{labelText}</label>
      <div className={styles.inputWrap}>
        <Input
          {...otherProps}
          className={classnames(styles.field, {
            [styles.error]: error,
            [styles.validating]: validating,
            [styles.hasTrailingText]: !!trailingText,
          })}
          data-testid={testid}
          inputRef={inputRef}
          name={fieldName}
          type={type}
        />
        {trailingText && (
          <span className={styles.trailingText}>{trailingText}</span>
        )}
      </div>
      {error && (
        <span
          role="alert"
          className={styles.errorText}
          data-testid={`${testid}_error`}
        >
          {error.message}
        </span>
      )}
    </div>
  );
}

InputField.propTypes = {
  error: PropTypes.shape({
    type: PropTypes.string.isRequired,
    message: PropTypes.string,
  }),
  fieldName: PropTypes.string.isRequired,
  inputRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  labelText: PropTypes.string.isRequired,
  testid: PropTypes.string.isRequired,
  trailingText: PropTypes.string,
  type: PropTypes.string,
  validating: PropTypes.bool,
};

InputField.defaultProps = {
  error: null,
  inputRef: null,
  trailingText: '',
  type: 'text',
  validating: false,
};
